module.exports = __webpack_public_path__ + "img/geo.99b21c2b.svg";